module.exports = __webpack_public_path__ + "static/media/TonoDaruma_06A.b61f0eda.gif";